import React, { FC } from 'react';

import { DataGrid, GridColDef, GridToolbarContainer } from '@mui/x-data-grid';
import { Autocomplete, LinearProgress, TextField } from '@mui/material';

import styles from './AutocompleteAssociationsTable.module.scss';
import { dataGridFocusStyles, dataGridFontSizeStyles } from 'styles';

interface AutocompleteAssociationsTableProps {
  displayedItems: {
    id: string;
    [key: string]: any /* Each item shouldn't have more than ONE of these (i.e. "email", "name" etc. ) */
  }[];
  unassociatedItems: any[];
  columns: GridColDef[];
  isLoading: boolean;
  onAddItem: (event: any, selectedItem: any) => Promise<void>;
  getOptionLabel: (option: any) => string;
  title: string;
}

const AutocompleteAssociationsTable: FC<AutocompleteAssociationsTableProps> = (
  {
    displayedItems,
    unassociatedItems,
    columns,
    isLoading,
    onAddItem,
    getOptionLabel,
    title
  } : AutocompleteAssociationsTableProps
) => {

  const Toolbar = (): JSX.Element => {
    return (
      <GridToolbarContainer>
        <div className="project-grid-toolbar-title">{title}</div>
        <div className="project-grid-toolbar-filters">
          <Autocomplete
            freeSolo
            size="small"
            options={unassociatedItems}
            blurOnSelect
            clearOnBlur
            clearOnEscape
            onChange={onAddItem}
            getOptionLabel={getOptionLabel}
            renderInput={(params) => (
              <TextField
                {...params}
                label={`Add ${title}`}
                placeholder="Search and add.."
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </div>
      </GridToolbarContainer>
    );
  };

  return (
    <div className={styles.AutocompleteAssociationsTable} data-testid="AutocompleteAssociationsTable">
      <DataGrid
        rows={displayedItems}
        columns={columns}
        slots={{
          loadingOverlay: LinearProgress,
          toolbar: Toolbar,
        }}
        loading={isLoading}
        className={styles.table}
        sx={{ ...dataGridFocusStyles, ...dataGridFontSizeStyles }}
        disableRowSelectionOnClick
        disableColumnMenu
        hideFooterPagination
        // hideFooter
        // columnHeaderHeight={48}
      />
    </div>
  );
}

export default AutocompleteAssociationsTable;
